





import { defineComponent } from '@vue/composition-api';

import PanelWithQuizEditor from '@/components/Live/PanelWithQuizEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithQuizEditor,
  },
  // setup() {},
});

export default Edit;
